<template>
  <multiselect
    v-bind="$attrs"
    v-on="forwardListeners"
    v-model="completeValue"
    :options="options"
    :track-by="trackBy"
    :limit="limit"
  >
    <!-- Pass on all named slots -->
    <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />
    <!-- Pass on all scoped slots -->
    <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </multiselect>
</template>
<script>
import Multiselect from 'vue-multiselect';

// See discussion on this issue:
// https://github.com/shentao/vue-multiselect/issues/385
export default {
  components: {
    Multiselect,
  },
  inheritAttrs: false,
  props: {
    value: {
      type: [Number, Boolean, String, Array],
      default: null,
    },
    options: {
      type: Array,
      default: null,
    },
    trackBy: {
      type: String,
      default: 'id',
    },
    limit: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    completeValue: {
      get() {
        return this.$attrs.multiple
          ? this.value.map(value => this.findOption(value))
          : this.findOption(this.value);
      },
      set(v) {
        this.$emit(
          'input',
          this.$attrs.multiple ? v.map(value => value[this.trackBy]) : v && v[this.trackBy],
        );
      },
    },
    forwardListeners() {
      const { input, ...listeners } = this.$listeners;
      return listeners;
    },
  },
  methods: {
    findOption(value) {
      return this.options.find(option => option[this.trackBy] === value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/KeyMultiSelect.vue